<template>
  <div class="table-header">
    <div class="dt-header" id="dt-header">
      <div class="header-col text-center"
            :style="{ width: getColumnWidth.eventName.size ? (getColumnWidth.eventName.size + 'px') : '12%' }"
            @click="setSortOption('eventName')" id="eventName">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('eventName', $event)"></div>
            <div class="content no-select">
              name
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'eventName'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'eventName' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'eventName' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col"
            :style="{ width: getColumnWidth.projPart.size ? (getColumnWidth.projPart.size + 'px') : '6%' }"
            @click="setSortOption('projPart', 1)" id="projPart">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('projPart', $event)"></div>
            <div class="content no-select">
              PART
              <span>
              <Icon name="sort" class="sort-icon"
                    v-if="this.pagingObj.sortType != 'projPart'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'projPart' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'projPart' && !this.pagingObj.sortReverse"></Icon>
            </span>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col"
            :style="{ width: getColumnWidth.fullAddress.size ? (getColumnWidth.fullAddress.size + 'px') : '26%' }"
            @click="setSortOption('fullAddress')" id="fullAddress">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('fullAddress', $event)"></div>
            <div class="content no-select">
              FULL ADDRESS
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'fullAddress'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'fullAddress' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'fullAddress' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col"
            :style="{ width: getColumnWidth.eventLocation.size ? (getColumnWidth.eventLocation.size + 'px') : '8%' }"
            @click="setSortOption('eventLocation')" id="eventLocation">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('eventLocation', $event)"></div>
            <div class="content no-select">
              LOCATION
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'eventLocation'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'eventLocation' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'eventLocation' && !this.pagingObj.sortReverse"></Icon>
            </div>
          </div>
        </div>
      </div>
      <div class="header-col"
            :style="{ width: getColumnWidth.startTime.size ? (getColumnWidth.startTime.size + 'px') : '7%' }"
            @click="setSortOption('startTime')" id="startTime">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('startTime', $event)"></div>
            <div class="content no-select">
              start
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'startTime'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'startTime' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'startTime' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col"
            :style="{ width: getColumnWidth.duration.size ? (getColumnWidth.duration.size + 'px') : '5%' }"
            @click="setSortOption('duration')" id="duration">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('duration', $event)"></div>
            <div class="content no-select">
              dur
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'duration'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'duration' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'duration' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col" 
          :style="{ width: getColumnWidth.endTime.size ? (getColumnWidth.endTime.size + 'px') : '7%' }"
            @click="setSortOption('endTime')" id="endTime">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('endTime', $event)"></div>
            <div class="content no-select">
              end
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'endTime'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'endTime' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'endTime' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col"
            :style="{ width: getColumnWidth.timeZone.size ? (getColumnWidth.timeZone.size + 'px') : '4%' }"
            @click="setSortOption('timeZone')" id="timeZone">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('timeZone', $event)"></div>
            <div class="content no-select">
              tz
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'timeZone'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'timeZone' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'timeZone' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col"
            :style="{ width: getColumnWidth.contactName.size ? (getColumnWidth.contactName.size + 'px') : '9%' }"
            @click="setSortOption('contactName')" id="contactName">
        <div class="header-container">
          <div class="crop">
            <div class="crop-line crop-right-line" @mousedown="changeColumnWidth('contactName', $event)"></div>
            <div class="content no-select">
              CONTACT
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'contactName'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'contactName' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'contactName' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
      <div class="header-col" 
          :style="{ width: getColumnWidth.prefDate.size ? (getColumnWidth.prefDate.size + 'px') : '11%' }"
            id="prefDate" @click="setSortOption('prefDate', 2)">
        <div class="header-container">
          <div class="crop">
            <div class="content no-select">
              DATE
              <Icon name="sort" class="sort-icon" v-if="this.pagingObj.sortType != 'prefDate'"></Icon>
              <Icon name="sort-up" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'prefDate' && this.pagingObj.sortReverse"></Icon>
              <Icon name="sort-down" class="sort-icon"
                    v-if="this.pagingObj.sortType == 'prefDate' && !this.pagingObj.sortReverse"></Icon>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import constants from '../../_consts';
  import 'vue-awesome/icons/sort';
  import 'vue-awesome/icons/sort-up';
  import 'vue-awesome/icons/sort-down';
  import Icon from 'vue-awesome/components/Icon';
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'table-header',
    components: {
      Icon
    },
    props: {},
    data () {
      return {
        pagingObj: {
          currentPage: 1,
          itemsPerPage: '25',
          totalItems: this.totalItems,
          sortType: 'isChangeOrder',
          sortReverse: false
        }
      }
    },
    computed: {
      ...mapGetters({
        getColumnWidth: 'GETTERS_GET_COLUMN_WIDTH'
      })
    },
    methods: {
      setSortOption (sortType, fieldType = 0) {
        this.pagingObj.sortType = sortType;
        this.pagingObj.sortReverse = !this.pagingObj.sortReverse;
        this.sortByFieldName({
          fieldName: sortType,
          isReverse: this.pagingObj.sortReverse,
          fieldType: fieldType
        });
      },
      changeColumnWidth (colName, mouseDownEvent) {
        this.resizing = true;
        let vueApp = this;
        // get current mouse position
        let shiftX = mouseDownEvent.clientX;
        // header width
        let dtHeaderEl = document.getElementById('dt-header');
        let headerWidth = dtHeaderEl.getBoundingClientRect().width;
        // get maximum width
        let maxLeft = this.getColumnWidth[colName].size ? this.getColumnWidth[colName].size : document.getElementById(colName).getBoundingClientRect().width;
        let newWidth = maxLeft;

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);

        function onMouseMove (event) {
          // new position
          let bufferPx = event.clientX - shiftX;
          let newHeaderWidth = headerWidth + bufferPx;

          if (bufferPx < 0 && (maxLeft - Math.abs(bufferPx)) < 20) {
            newWidth = 20;
            newHeaderWidth = headerWidth - (maxLeft - 20);
          } else {
            newWidth = maxLeft + bufferPx;
          }

          // save data
          vueApp.saveColumnWidth({
            headerWidth: headerWidth,
            newHeaderWidth: newHeaderWidth,
            colName: colName,
            newWidth: newWidth.toFixed(2)
          });
        }

        function onMouseUp () {
          document.removeEventListener('mouseup', onMouseUp);
          document.removeEventListener('mousemove', onMouseMove);
          setTimeout(() => {
            vueApp.resizing = false;
          }, 50);
        }
      },
      ...mapActions({
        saveColumnWidth: 'ACTION_SAVE_COLUMN_WIDTH'
      }),
      ...mapMutations({
        sortByFieldName: 'MUTATION_SORT_EVENT_BY_FIELD_NAME'
      })
    },
    mounted: function () {
    }
  }
</script>

<style lang="less">
  @import '../../styles/variables.less';

  .table-header {
    color: @grey-7;
    font-family: @font-family-main;
    font-size: 12px;
    letter-spacing: 0.1px;
    height: 40px;
    padding: 12px 0px;
    
    .dt-header {
      .text-center {
        text-align: center;
      }
      .header-col {
        float: left;
        overflow: hidden;
        padding-left: 8px;
        text-transform: uppercase;
        word-break: break-all;

        .content {
          height: 16px;
        }
        .sort-icon {
          vertical-align: middle;
          width: 6px;
          height: 10px;
          margin: 5px;
        }
        .header-container {
          position: relative;
        }
        .crop {
          // height: 37px;
          transition: all 0.25s;
          cursor: pointer;
        }

        .crop .crop-line {
          position: absolute;
          transition: all 0.25s;
        }
        .crop:hover .crop-line {
          border-color: @grey-3;
        }
        .crop .crop-top-line {
          top: 0;
          left: 0;
          right: 0;
          border-top: 1px solid @grey-3;
          cursor: n-resize;
          height: 16px;
        }
        .crop .crop-bottom-line {
          bottom: 0;
          left: 0;
          right: 0;
          height: 5px; /* 5px for the mouse cursor update size */
          border-bottom: 1px solid @grey-3;
          cursor: s-resize;
        }
        .crop .crop-left-line {
          top: 0;
          left: 0;
          bottom: 0;
          width: 5px; /* 5px for the mouse cursor update size */
          border-left: 1px solid @grey-3;
          cursor: col-resize;
        }
        .crop .crop-right-line {
          top: 0;
          right: 0;
          bottom: 0;
          width: 5px; /* 5px for the mouse cursor update size */
          border-right: 1px solid @grey-3;
          cursor: col-resize;
        }
        .crop .crop-corner {
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 2px;
          border: 1px solid #808080;
          background: #FFF;
          opacity: 0;
          transition: all 0.25s;
        }
        .crop .crop-top-left-corner {
          top: -3px;
          left: -3px;
          cursor: nw-resize;
        }
        .crop .crop-top-right-corner {
          top: -3px;
          right: -3px;
          cursor: ne-resize;
        }
        .crop .crop-bottom-left-corner {
          bottom: -3px;
          left: -3px;
          cursor: sw-resize;
        }
        .crop .crop-bottom-right-corner {
          bottom: -3px;
          right: -3px;
          cursor: se-resize;
        }
        .crop:hover .crop-corner {
          opacity: 1;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// TableHeader.vue?f743be08